export const IS_CLOUD = plugin.runtimeEnvironment === 'cloud';

export const FEATURE_FLAG = {
  // by default all features are free, isPremium flag stands for
  // features available in paid version
  isPremium: !plugin.isFree,

  // use endpoint /picker over /search to find an issues
  // CLOUD works good, SERVER /picker is buggy
  useSearchIssuePicker: IS_CLOUD,
};

export const UPGRADE_TO_QALITY_PLUS_TOOLTIP_MESSAGE =
  'Upgrade to QAlity Plus to unlock this field.';

export const PREMIUM_FEATURE_TOOLTIP_MESSAGE =
  'Feature available in QAlity Plus.';
